/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobFilter {
    getFixupPrototypeFunction() { return BackgroundJobFilter.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobFilter>): BackgroundJobFilter {
        let obj = Object.assign(new BackgroundJobFilter(), model);
        BackgroundJobFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobFilter>): BackgroundJobFilter {
        if (!model) return null;
        return BackgroundJobFilter.newInstance(<BackgroundJobFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobFilter) {
        if (!obj) return;

        models.BackgroundJobFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobFilter): boolean {
        Object.setPrototypeOf(obj, BackgroundJobFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Limit results to jobs from this executor
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Limit results to jobs with the same payload type
     */
    payload_type: string;

    /**
     * Limit results to jobs with the same payload identifier
     */
    payload_identifier: string;

    /**
     * Sets of Status values to filter on
     */
    status: Array<models.BackgroundJobStatus>;

}
